export default [
  {
    path: 'settings',
    children: [
      {
        name: 'configuration-settings',
        path: '',
        component: () => import('./SettingsForm.vue'),
        meta: { title: 'Settings' }
      },
    ]
  },
]
